<template>
  <div class="quizzes-wrapper bdc-dialog"
              ref="dialog"
              :is-disable-close="true"
              :is-show-footer="!isExam">
    <div class="bdc-dialog-wrap"  ref="wrap">
      <div class="ready" v-if="isSceneReady">
        <div class="dialog-logo-wrap">
          <img class="review-image" v-show="quizType === 'active_review'"  src="https://vanthink.oss-cn-qingdao.aliyuncs.com/a229f9f27378c91750bfed46eb79ca1a.png" alt="">
          <img class="normal-image" v-show="quizType !== 'active_review'" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/7be6826d4b01861555c41e79af924283.png" alt="">
        </div>
        <h1>{{ title }}</h1>
        <br />
        <h2 v-html="subtitle"></h2>
        <h3 class="description" v-if="description" v-html="description"></h3>
        <br />
        <div class="btn-control">
          <div
            class="btn btn-orange-square"
            v-if="quizzes.length" @click="scene = 2">
            <template v-if="isExam">
              <template v-if="isLearnBeforeTest || isLearnAfterTest">开始测试</template>
              <template v-else>开始考试</template>
            </template>
            <template v-else>{{quizType === 'active_review ' ? '开始复习' : '开始学习'}}</template>
          </div>
          <div
            class="btn btn-blue-square"
            v-if="isLearnBeforeTest"
            @click="skipBeforeTest">放弃测试</div>
        </div>
      </div>
    <div class="ready" v-if="isSceneError">
      <h2>{{errMsg || '哎呦~好像网络出了问题，请点击下面的重试按钮。'}}</h2>
      <br />
      <div>
        <el-button
            class="btn btn-blue-square"
            v-if="!errCode"
            @click="close">
          重试
        </el-button>
      </div>
    </div>
      <template v-else-if="isScenePlaying">
        <van-exam
          v-if="isExam"
          :exercises="newQuizzes"
          :quiz-type="quizType"
          :mode="examType"
          :course-id="courseId"
          :unit-id="unitId"
          :name="navigation"
          @continue="continueLearning({ scene: 1 })"
          @finished="close"
          @showReport="showBdcReport"
          :next-unit-id="nextUnitId"
          @submitted="submittedExam"
          @scoring="scoring"
          @openCertificate="openCertificate"
          @learnNext="learnNext"
        />
        <van-quizzes-controller
            v-else
            ref="controller"
            :exercises="newQuizzes"
            :is-exam="isExam"
            :is-show-speaker="!!(currentExercise.code !== 'DCPX' && this.currentExercise.audio)"
            :is-show-hint="!isExam"
            :quiz-type="quizType"
            :book-mode="bookMode"
            :exam-results="results"
            :user-answer="userAnswer"
            @exercise-change="exerciseChange"
            @change="change"
            @finish="finish"
            @scoring="scoring"
            @submit="submitResult" />
      </template>
      <div class="finished" v-else-if="scene === 3">
        <div class="flex-wrap" v-if="isLearnAfterTest || isLearnBeforeTest">
          <van-exam
            :exercises="newQuizzes"
            :extend="{results, score, response}"
            :name="navigation"
            :next-unit-id="nextUnitId"
            :quiz-type="quizType"
            is-preview
            @openCertificate="openCertificate"
            @learnNext="learnNext"
          >
            <template slot="control" v-if="isLearnAfterTest">
              <el-button class="btn btn-blue-square" @click="replay('wrongs')" v-if="isHasWrongs">
                错题再练
              </el-button>
              <el-button class="btn btn-blue-square" @click="close">完成</el-button>
            </template>
            <template slot="control" v-if="isLearnBeforeTest">
              <el-button
                class="btn btn-blue-square"
                @click="continueLearning({ scene: 1 })">
                继续学习
              </el-button>
            </template>
            <template slot="before-exam-tips">
              <span class="tips" v-html="message"></span>
            </template>
          </van-exam>
        </div>
        <div class="flex-wrap" v-else>
          <h1>{{ title }}</h1>
          <h2>
            <template
              v-if="!bookReview && quizType === 'learn'
              && progress !== 100">太棒了！</template>
            <template v-else-if="
              !bookReview
              && quizType === 'learn'
              && progress === 100">
              你已完成本单元学习，需要进行本单元整体复习吗？
            </template>
            <template v-else-if="bookReview">
              太棒了！你已完成本书{{bookReview === 'book_half_push' ? '一半' : '全部'}}内容，可以对已学单元进行整体复习哦！
            </template>
            <template v-else-if="quizType === 'active_review'
              || quizType === 'force'
              || quizType === 'all_book'
              || quizType === 'half_book'">好棒！温故而知新，坚持下去你真的会变成学霸哦！</template>
            <template v-else-if="quizType === 'student_wrong'">恭喜你完成本次易错词的强化训练。</template>
            <template v-else-if="quizType === 'book_one_side'">太牛了！你离学霸之路越来越近啦！</template>
          </h2>
          <h3 class="description" v-html="message">
          </h3>
          <div class="btn-control">
            <template v-if="bookReview">
              <el-button
                class="btn btn-orange-square"
                @click="startReview('bdc_book_review')">
                开始复习
              </el-button>
              <el-button class="btn btn-blue-square" @click="close">暂不复习</el-button>
            </template>
            <template v-else-if="!bookReview && quizType === 'learn' && progress !== 100">
              <el-button
                class="btn btn-orange-square"
                @click="continueLearning">
                再来一组
              </el-button>
            </template>
            <template v-else-if="
              !bookReview
              && quizType === 'learn'
              && progress === 100">
                <el-button
                  class="btn btn-orange-square"
                  @click="startReview('bdc_review')">
                  开始复习
                </el-button>
                <el-button class="btn btn-blue-square" @click="close">退出</el-button>
            </template>
            <template v-else-if="
              !bookReview
              && quizType === 'force'">
                <el-button
                  class="btn btn-orange-square"
                  @click="continueLearning({ scene: 1 })">
                  开始新学
                </el-button>
            </template>
            <template v-else>
              <el-button class="btn btn-blue-square" @click="close">退出</el-button>
            </template>
          </div>
        </div>
      </div>
    </div>
    <van-certificate
      :info="reportInfo"
      v-show="isShowBdcReport"
      :results="reportResults"
      :is-replay="!!reportResults.length"
      @close="isShowBdcReport = false"
    />
    <exam-confirm-dialog
      @cancel="cancel"
      @confirm="confirm"
      ref="exam-confirm">
      <template slot="title">放弃测试</template>
      <template slot="text">确定要放弃学前测试吗？放弃的话成绩会是0分哦！</template>
    </exam-confirm-dialog>
  </div>
</template>

<script>
import { Button } from 'element-ui';
import utils from '@/services/utils';
import VanQuizzesController from '@/components/quizzes/bdc/Quizzes.vue';
import ExamConfirmDialog from '@/components/quizzes/ExamConfirmDialog.vue';
import VanExam from '@/components/quizzes/bdc/Exam.vue';
import VanCertificate from '@/components/quizzes/bdc/Certificate.vue';
import api from '@/api/graphql/englishCourse';
import api1 from '@/api/graphql/course';

const SCENE = Object.freeze({
  ready: 1,
  playing: 2,
  finished: 3,
  error: 4,
});

export default {
  components: {
    ElButton: Button,
    VanQuizzesController,
    VanExam,
    VanCertificate,
    ExamConfirmDialog,
  },
  props: {
    courseId: {
      type: Number,
      default: 0,
    },
    isScoring: {
      type: Boolean,
      default: false,
    },
    course: {
      type: Object,
      default: () => {},
    },
    unitId: {
      type: Number,
      default: -1,
    },
    isExam: {
      type: Boolean,
      default: false,
    },
    examType: {
      type: String,
      default: '',
    },
    navigation: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    quizType: {
      type: String,
      default: '',
    },
    quizzes: {
      type: Array,
      default: () => ([]),
    },
    bookMode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      scene: SCENE.ready,
      score: 0,
      results: [],
      exerciseIndex: 0,
      seconds: 0,
      bookReview: '', // 是否是本书复习
      progress: 0, // 完成率
      isComplete: false,
      newQuizzes: [],
      message: '',
      response: null,
      isShowBdcReport: false,
      reportResults: [],
      reportInfo: {},
      unitList: [],
      currentUnitId: this.unitId,
      nextUnitId: 0,
      errCode: null,
    };
  },
  watch: {
    quizzes() {
      this.newQuizzes = this.quizzes.map((item, index) => ({
        ...item,
        index,
        errorCount: 0,
        spendTime: 0,
        isRight: false,
        userAnswer: null,
        isComplete: false,
      }));
      this.results = this.quizzes.map((item, index) => ({
        ...item,
        index,
        isRight: false,
        userAnswer: null,
        isComplete: false,
      }));
    },
    quizType() {
      if (this.quizType === 'online' || this.quizType === 'book_learn') {
        this.scene = 2;
      }
      if (this.quizType !== 'student_wrong') {
        this.fetchUnitList();
      }
    },
    unitId() {
      this.currentUnitId = this.unitId;
    },
  },
  computed: {
    isSceneReady() {
      return this.scene === SCENE.ready;
    },
    isScenePlaying() {
      return this.scene === SCENE.playing;
    },
    currentExercise() {
      return this.newQuizzes[this.exerciseIndex];
    },
    userAnswer() {
      if (this.isExam) {
        return this.results[this.exerciseIndex].userAnswer || null;
      }
      return null;
    },
    isLearnBeforeTest() {
      return this.quizType === 'learn_before_test';
    },
    isLearnAfterTest() {
      return this.quizType === 'learn_after_test';
    },
    isHasWrongs() {
      return this.results.some(result => !result.isRight);
    },
    isArticleExam() {
      return this.newQuizzes.every(item => item.code === 'YDLJ');
    },
    isSceneError() {
      return this.scene === SCENE.error;
    },
  },
  methods: {
    disableCopy() {
      const el = document.querySelector('.bdc-dialog');
      el.oncontextmenu = (e) => {
        e.preventDefault();
      };

      el.onselectstart = (e) => {
        e.preventDefault();
      };

      el.oncopy = (e) => {
        e.preventDefault();
      };

      el.onkeydown = e => !(e.ctrlKey || e.ctrlKey || e.shiftKey);
    },
    fetchUnitList() {
      api1.getWordUnitList({
        courseId: this.courseId,
      }).then(({ wordUnitList }) => {
        this.computedNextUnit(wordUnitList);
      });
    },
    computedNextUnit(list) {
      this.unitList = list;
      const index = utils.Array.findIndex(list, { id: this.currentUnitId }, 'id');

      const isLast = index >= list.length - 1;

      this.nextUnitId = !isLast ? list[index + 1].id : 0;
    },
    openCertificate({ response, results }) {
      this.showBdcReport({
        response,
        results,
      });
    },
    open() {
      this.reset();
      this.$nextTick(() => {
        this.bindEnterEvent();
      });
      this.$refs.dialog.open();
    },
    close() {
      if (this.bookReview) {
        const type = this.bookReview === 'book_half_push' ? 'bdc_half_book' : 'bdc_all_book';
        api.submitCourseResult({
          courseId: this.courseId,
          unitId: this.unitId,
          type,
          mode: this.examType,
          spend: [],
          quizzes: [],
        }).then(() => {});
      }
      this.unBindEnterEvent();
      this.reset();
      this.$emit('close');
    },
    reset(scene) {
      this.exerciseIndex = 0;
      this.results = [];
      this.isComplete = false;
      this.bookReview = '';
      this.scene = scene || SCENE.ready;
    },
    continueLearning({ scene = '', res } = {}) {
      this.reset();
      this.$emit('continue', 'bdc_learn', scene, {
        unitId: this.unitId,
        ...res,
      });
    },
    startReview(type) {
      this.reset();
      this.$emit('continue', type);
    },
    finish(payload) {
      this.submitResult(payload);
    },
    submitResult(payload) {
      if (this.quizType === 'level' || this.quizType === 'active_review') {
        this.$emit('submit', {
          type: `bdc_${this.quizType}`,
          spend: JSON.stringify(payload.spend),
          seconds: payload.spend
            .reduce((pre, cur) => ({ spendTime: pre.spendTime + cur.spendTime })).spendTime,
          data: payload.results,
          isHalf: payload.isHalf,
        });
        return;
      }
      api.submitCourseResult({
        courseId: this.courseId,
        unitId: this.unitId,
        type: `bdc_${this.quizType}`,
        mode: this.examType,
        seconds: 0,
        spend: JSON.stringify(payload.spend),
        quizzes: payload.results,
      }).then(({ englishCourseResult }) => {
        this.bookReview = englishCourseResult.bookReview;
        this.progress = englishCourseResult.progress;
        this.message = englishCourseResult.message;
        if (this.bookReview === 'learn_after_test') {
          this.continueLearning({
            scene: SCENE.ready,
          });
        } else {
          this.scene = SCENE.finished;
        }
      }).catch(() => {
        this.close();
      });
    },
    skipBeforeTest() {
      this.$refs['exam-confirm'].open();
    },
    submittedExam({
      score,
      results,
      response,
      isArticleExam,
    } = {}) {
      /* eslint-disable no-lonely-if */
      this.fetchUnitList();
      if (this.isLearnBeforeTest || this.isLearnAfterTest) {
        if (isArticleExam || this.isArticleExam) {
          if (this.isLearnBeforeTest) {
            this.continueLearning({ scene: 1 });
          } else {
            this.close();
          }
          return;
        }
        this.newQuizzes = results.map(result => ({
          ...result.ref,
          userAnswer: result.answer,
        }));
        this.message = response.message.replace(/(\d+)/, '<span>$1</span>');
        this.results = results;
        this.score = score;
        this.scene = SCENE.finished;
        this.response = response;
      }
      if (score >= 100
      && (this.quizType === 'learn_after_test' || this.quizType === 'learn_before_test')) {
        this.showBdcReport({ response, results });
      }
    },
    replay(type) {
      let quizzes;
      if (type === 'wrongs') {
        quizzes = this.results.filter(result => !result.isRight)
          .map(result => ({
            ...result.ref,
            userAnswer: result.answer,
          }));
      }
      this.$emit('replay', {
        quizzes,
        type: 'wrongs',
      });
    },
    exerciseChange({ exerciseIndex }) {
      // when isExam is true 生效
      this.exerciseIndex = exerciseIndex;
    },
    change(payload) {
      this.results.forEach((item) => {
        if (item.id === payload.id && item.code === payload.code && item.mode === payload.mode) {
          item.isRight = payload.isRight;
          item.isComplete = payload.isComplete;
          item.userAnswer = payload.userAnswer;
        }
      });
    },
    handleSubmitExamBtn() {
      this.$refs.controller.submit();
      this.scene = SCENE.finished;
    },
    handleGlobalEnter(event) {
      if (this.isSceneReady && event.keyCode === 13) {
        this.scene = SCENE.playing;
      }
    },
    bindEnterEvent() {
      document.addEventListener('keyup', this.handleGlobalEnter);
    },
    unBindEnterEvent() {
      document.removeEventListener('keyup', this.handleGlobalEnter);
    },
    learnNext() {
      this.computedNextUnit(this.unitList);
      this.continueLearning({
        scene: 1,
        res: { unitId: this.nextUnitId },
      });
    },
    showBdcReport({ results, response }) {
      this.isShowBdcReport = true;
      this.reportResults = results.filter(result => !result.isRight)
        .map(result => ({
          ...result.ref,
          userAnswer: result.answer,
        }));
      this.reportInfo = {
        examId: response.examId,
        schoolName: response.schoolName,
        name: response.name,
        courseName: this.course.name,
        unitName: response.unitName,
        score: response.score,
        wordCount: response.wordCount,
        beforeWordCount: response.beforeWordCount,
        time: response.time,
        qrcode: response.qrcode,
        certificateId: response.examId,
      };
    },
    cancel() {
      this.$refs['exam-confirm'].close();
    },
    confirm() {
      api.submitCourseResult({
        courseId: this.courseId,
        unitId: this.unitId,
        type: `bdc_${this.quizType}`,
        mode: this.examType,
        seconds: 0,
        spend: '',
        quizzes: this.newQuizzes.map(quiz => ({
          id: quiz.id,
          status: 0,
          errorCount: 1,
          answer: JSON.stringify([{
            code: quiz.code,
            mode: quiz.mode,
            userAnswer: '',
          }]),
        })),
      })
        .then(({ englishCourseResult: response }) => {
          this.$refs['exam-confirm'].close();
          this.submittedExam({
            score: 0,
            results: this.newQuizzes.map((quiz, index) => ({
              id: quiz.id,
              answer: '',
              isRight: false,
              isComplete: false,
              key: `${quiz.id}_${quiz.code}_${quiz.mode}`,
              ref: quiz,
              index,
            })),
            response,
          });
        });
    },
    scoring({ quizzes }) {
      if (!this.isScoring) return;

      api.englishScoring({
        courseId: this.courseId,
        unitId: this.unitId,
        type: this.examType || this.quizType,
        quizzes: JSON.stringify(quizzes),
      });
    },
    error({ code, message } = {}) {
      this.scene = SCENE.error;

      if (code) {
        this.errMsg = message;
        this.errCode = code;
      } else {
        this.errMsg = '';
        this.errCode = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import '@/styles/common/tip-line.scss';

  .bdc-dialog {
    overflow-y: auto;
    user-select: none;
    .bdc-dialog-wrap {
      box-sizing: border-box;
      height: 100%;
      overflow-y: auto;
      .ready {
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .dialog-logo-wrap {
          .review-image {
            width: 15%;
          }
          .normal-image {
            width: 45%;
          }
        }
        .description {
          span {
            color: $primary;
          }
        }
        .el-button {
          min-width: 120px;
        }
      }
      .time {
        position: absolute;
        top: 10px;
        right: 0;
        transform: translateX(-50%);
        font-size: 22px;
        color: $primary;
      }
      .finished {
        height: 100%;
        .flex-wrap {
          height: 100%;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .btn-control {
            margin-top: 70px;
          }
          .description {
            span {
              color: $primary;
            }
          }
        }
      }
      .tip-line {
        margin-top: 20px;
      }
      .exam-control {
        box-sizing: border-box;
        position: absolute;
        bottom: 0;
        padding: 5px 20px;
        width: 100%;
      }
      .btn-control {
        display: flex;
        justify-content: center;
        .btn {
          margin: 0 30px;
          min-width: 120px;
        }
      }
    }
  }
</style>
